import { useDispatch, useSelector } from 'react-redux'
import { setSelectedFeatures, setClickedFeature } from '@/actions'

const useClearSelection = () => {
  const dispatch = useDispatch()
  const mapStyle = useSelector((state: { mapStyle: any }) => state.mapStyle)

  const clearSelection = () => {
    const clickedFeatureLayer = mapStyle?.layers?.find(
      (layer: any) => layer.id === 'clicked_feature'
    )
    if (!clickedFeatureLayer) return

    // Reset the clicked-feature highlight back to pointing at its own (empty)
    // source, dropping any borrowed source-layer.
    const resetLayer = { ...clickedFeatureLayer, source: 'clicked_feature' }
    delete resetLayer['source-layer']
    dispatch(setClickedFeature({ layer: resetLayer }))
    // Empty the cyan selection highlight.
    dispatch(setSelectedFeatures([]))
  }

  return clearSelection
}

export default useClearSelection
